import _ from 'lodash';
import {RouteService} from "../../../../services/routeService";
import {NotificationService} from "../../../../services/notificationService";
import {GeneralService} from "../../../../services/generalService";
import {DICTIONARY} from "../../../../dictionary";
import {Component, OnInit, ViewChild} from "@angular/core";
import {ClipboardService} from "ngx-clipboard";
import {Router} from "@angular/router";
import moment from "moment/moment";
import {TableQueryTemplatesService} from "../../../../services/tableQueryTemplatesService";
import {TrustifiTableComponent} from "../../../uiComponents/trustifi-table/trustifi-table.component";


@Component({
	selector: 'inbound-quarantined-component',
	templateUrl: './inbound-quarantined.component.html',
})

export class InboundQuarantinedComponent implements OnInit {

	@ViewChild('quarantinedTable') quarantinedTable: TrustifiTableComponent;

    constructor(public gs:GeneralService,
				private ns:NotificationService,
				private rs:RouteService,
				public tableQueryTemplatesService:TableQueryTemplatesService,
				private clipboard: ClipboardService,
				private router:Router) {

		this.autoRefreshMenuData = {
			tooltip: 'Refresh data automatically',
			iconClass: 'far fa-history',
			items: [
				{label: 'Every 30 Seconds', action: this.initAutoRefresh},
				{label: 'Every 60 Seconds', action: this.initAutoRefresh},
				{label: 'Off', action: this.initAutoRefresh},
			]
		};

    }

    dic = DICTIONARY;
	_=_;
	displayViewAllPlansBtn: boolean = false;
	/** False until getQuarantinedPlanInfo finishes (avoids wrong security-reviewer subtitle before plan context exists). */
	quarantinedPlanInfoLoaded = false;
	viewAllPlans: boolean = false;
	viewMyPlanOnly: boolean = false;
	viewPlanList;
	pocPlans = [];
    showAbortLoadingEmailsLabel: boolean;
	abortLoadingFlag: any;
	activeAutoRefreshLoop;
    currentQuery: any;
	isImportantQuery = false;
    batchesCounter = 0;
	notifyOptionsPopup: any;
	isRecipientChangeNotifyTimeAllowed;
	searchPlanTxt;

    searchPeriod = [
        this.dic.CONSTANTS.trendsPeriod.lastDay,
        this.dic.CONSTANTS.trendsPeriod.last3Days,
        this.dic.CONSTANTS.trendsPeriod.lastWeek,
        this.dic.CONSTANTS.trendsPeriod.lastMonth,
		this.dic.CONSTANTS.trendsPeriod.last3Months,
		this.dic.CONSTANTS.trendsPeriod.range
    ];

	queryTypes = {
        normal: 'normal',
        messageIdOnly: 'messageIdOnly'
    }

    reviewerInfo = this.gs.reviewerInfo;
    userInfo;
    groupEmails = [];
    emails = [];
	groupBySender = false;
	activeFilters;
    activeTagAsFilter;
    rules;
    allowReviewerShowContent;
    queryType;
    quarantinedQuery;
    resultsPeriod;
    range;
    quarantinedQueryDisplay;
    queryValidationErrors;
	showQueryModal = false;
    isQueryError;
    getEmailsInProcess;
    filterData;
	powershellQuarantineEnabled;
	isExchangeConnected;
	mailboxInfo;
	emailsSources = {
		trustifi: 'Trustifi',
		exchange: 'Microsoft Exchange'
	};
	quarantineSubjectFilters = DICTIONARY.CONSTANTS.quarantineSubjectFilters;
	securityReviewerWeeklyReleasesTotal = 0;
	securityReviewerWeeklyReleasesInProcess = false;
	securityReviewerWeeklyTopTags: {sub_status: string; count: number; colorObj: {color: string; icon: string; loading?: boolean}}[] = [];
	/** True after at least one completed Get Emails refresh updated weekly stats (Trustifi or Exchange). */
	securityReviewerWeeklyStatsFromFetch = false;

	/**
	 * Multi-plan control admin with plan dropdown, but no scope selected (same case as dropdown label "Select a plan").
	 * Not the same as displayViewAllPlansBtn — "My plan" / "All plans" / any checkboxes mean a scope is chosen.
	 */
	get quarantinedViewNeedsPlanSelection(): boolean {
		if (!this.displayViewAllPlansBtn || !this.viewPlanList?.length) {
			return false;
		}
		if (this.viewMyPlanOnly) {
			return false;
		}
		if (_.every(this.viewPlanList, 'selected')) {
			return false;
		}
		return !_.some(this.viewPlanList, 'selected');
	}

	doNotChangeIsExpandedStates;
	autoRefreshMenuData;

	quarantinedEmailAction;
	quarantinedPlanInfo;

	threatNavigationEmails: any[] = [];
	currentThreatNavigationIndex = -1;
	// bulk "Threat analysis": the selected emails, walked one by one (slideshow)
	selectionReviewQueue: any[] = [];

	ngOnInit() {
        this.gs.getUserInfo(false, (userInfo) => {
            this.userInfo = userInfo;
        });

		this.rs.getQuarantinedPlanInfo().then((response) => {
			this.quarantinedPlanInfoLoaded = true;
			this.quarantinedPlanInfo = response;
			this.rules = response.rules;
			this.allowReviewerShowContent = response.allowReviewerShowContent;
			this.isRecipientChangeNotifyTimeAllowed = response.isRecipientChangeNotifyTimeAllowed;
			this.powershellQuarantineEnabled = response.powershellQuarantine;
			this.isExchangeConnected = response.isExchangeConnected;

			this.displayViewAllPlansBtn = this.gs.planAdmins?.length > 1 && this.gs.controlAdmin?.email === this.gs.planAdmins[0].email;
			if (this.displayViewAllPlansBtn) {
				this.viewPlanList = _.cloneDeep(this.gs.planAdmins);
				this.viewMyPlanOnly = true;
				this.viewPlanList[0].selected = true;
				if (!this.gs.planAdmins[0].alloc_plan_id) {
					this.viewPlanList[0].alloc_plan_id = this.userInfo.plan;
				}

				this.gs.planAdmins.forEach((adminObj) => {
					if (adminObj.alloc_plan_id?.plan_sub_type === this.dic.CONSTANTS.planSubType.poc) {
						this.pocPlans.push(adminObj.alloc_plan_id._id.toString());
					}
				});
			}

			if (this.reviewerInfo?.is_security_reviewer) {
				if (this.quarantinedViewNeedsPlanSelection) {
					this.securityReviewerWeeklyReleasesTotal = 0;
					this.securityReviewerWeeklyTopTags = [];
					this.securityReviewerWeeklyReleasesInProcess = false;
					this.securityReviewerWeeklyStatsFromFetch = false;
				}
				else {
					this.securityReviewerWeeklyReleasesInProcess = false;
					this.securityReviewerWeeklyStatsFromFetch = false;
				}
			}

			this.initFilters();

			this.prepareFirstQuery();
        }, (err) => {
			this.quarantinedPlanInfoLoaded = true;
		});

		this.rs.getMailboxInfo().then((response) => {
			this.mailboxInfo = response;
		}, (err) => {});
    };

	ngOnDestroy(): void {
		this.abortLoadingFlag = true;
	}

	updateSecurityReviewerWeeklyStatsFromLoadedEmails = () => {
		if (!this.reviewerInfo?.is_security_reviewer) {
			return;
		}
		if (this.quarantinedViewNeedsPlanSelection) {
			this.securityReviewerWeeklyReleasesTotal = 0;
			this.securityReviewerWeeklyTopTags = [];
			this.securityReviewerWeeklyReleasesInProcess = false;
			this.securityReviewerWeeklyStatsFromFetch = false;
			return;
		}
		if (this.currentQuery?.source !== this.emailsSources.trustifi) {
			this.securityReviewerWeeklyReleasesTotal = 0;
			this.securityReviewerWeeklyTopTags = [];
			this.securityReviewerWeeklyReleasesInProcess = false;
			this.securityReviewerWeeklyStatsFromFetch = true;
			return;
		}
		const weeklyReleased = this.getWeeklyReleasedEmailsForSecurityReviewerStats();
		this.securityReviewerWeeklyReleasesTotal = weeklyReleased.length;
		const loadedForTopTags = this.getLoadedEmailsForSecurityReviewerTopTags();
		this.securityReviewerWeeklyTopTags = this.computeSecurityReviewerWeeklyTopTags(loadedForTopTags);
		this.securityReviewerWeeklyReleasesInProcess = false;
		this.securityReviewerWeeklyStatsFromFetch = true;
	};

	getWeeklyReleasedEmailsForSecurityReviewerStats = () => {
		if (!this.emails?.length) {
			return [];
		}
		const releaseStatus = this.dic.CONSTANTS.quarantinedActions.release.value;
		const since = moment().subtract(7, 'days');
		return this.emails.filter((email) => {
			if (email.status !== releaseStatus) {
				return false;
			}
			if (!email.created || !moment(email.created).isValid()) {
				return false;
			}
			if (!moment(email.created).isSameOrAfter(since)) {
				return false;
			}
			const malStatus = email.malicious?.status;
			if (['Safe', 'External', 'Pending'].includes(malStatus)) {
				return false;
			}
			if (email.reason != null && email.reason !== '' && typeof email.reason === 'string' && !/\S+@\S+\.\S+/.test(email.reason)) {
				return false;
			}
			return true;
		});
	};

	getLoadedEmailsForSecurityReviewerTopTags = () => {
		return this.emails?.length ? this.emails : [];
	};

	collectWeeklyThreatTagEntriesForEmail = (email: any) => {
		const pairs: {name: string; status: string}[] = [];
		const seen = new Set<string>();
		const tp = email?.malicious?.tpResults;
		if (!tp) {
			return pairs;
		}
		const finalStatusesExcludedFromTopTags = new Set(['Safe', 'External', 'Pending', 'Unknown']);
		const pushNamesFromSection = (r: any) => {
			if (!r) {
				return;
			}
			if (finalStatusesExcludedFromTopTags.has(r.status)) {
				return;
			}
			const raw = r.sub_status;
			if (raw == null) {
				return;
			}
			const pushName = (name: string) => {
				if (!name || seen.has(name)) {
					return;
				}
				seen.add(name);
				pairs.push({name, status: r.status});
			};
			if (typeof raw === 'string') {
				pushName(raw);
				return;
			}
			if (Array.isArray(raw)) {
				raw.forEach((item) => {
					if (typeof item === 'string' && item.length) {
						pushName(item);
					}
					else if (item?.name && typeof item.name === 'string') {
						pushName(item.name);
					}
				});
			}
		};
		(['resHead', 'resUrl', 'resHash'] as const).forEach((key) => pushNamesFromSection(tp[key]));
		return pairs;
	};

	computeSecurityReviewerWeeklyTopTags = (emails: any[]) => {
		const counts: Record<string, number> = {};
		const colorObj: Record<string, {color: string; icon: string; loading?: boolean}> = {};
		for (const email of emails || []) {
			for (const {name, status} of this.collectWeeklyThreatTagEntriesForEmail(email)) {
				counts[name] = (counts[name] || 0) + 1;
				if (!colorObj[name]) {
					colorObj[name] = this.setInboundStatusStyles(status);
				}
			}
		}
		return _.orderBy(Object.entries(counts), ([, c]) => c, 'desc')
			.slice(0, 5)
			.map(([sub_status, count]) => ({sub_status, count, colorObj: colorObj[sub_status]}));
	};

	trackSecurityReviewerWeeklyTag = (_index: number, tag: {sub_status: string}) => tag.sub_status;

	prepareFirstQuery = () => {
		// default query
		this.initQuarantinedQuery();

		// predefined message-id-based query OR predefined query from WA page link
		if (this.setQueryFromOutside()) {
			this.applyQuery();
			return;
		}

		// restore last used query from Local Storage
		const userSpecificKey = `quarantinedQuery_${this.userInfo?.email}_${this.userInfo?.plan?._id?.toString()}`;
		if (localStorage[userSpecificKey]) {
			this.restoreQuarantinedQueryFromLocalStorage();

			// extra check if source can be other than Trustifi during loading time
			if (!this.isExchangeConnected || !this.powershellQuarantineEnabled) {
				this.quarantinedQuery.source = this.emailsSources.trustifi;
			}
		}

		this.calculateQueryDisplay();

		// saved query template
		this.getTableQueryTemplates();
	}

    selectQueryTemplate = (query) => {
		this.queryType = query.queryType;
		if (this.queryType === this.queryTypes.messageIdOnly) {
			this.quarantinedQuery.message_id = query.message_id;
		}
		else {
			this.resultsPeriod = query.period;
			this.range = query.range;

			this.quarantinedQuery.mailbox_email = query.mailbox_email;
			this.quarantinedQuery.sender = query.sender;
			this.quarantinedQuery.subject = query.subject;
			this.quarantinedQuery.link = query.link;
			this.quarantinedQuery.file = query.file;
			this.quarantinedQuery.source = query.source || this.emailsSources.trustifi;

			Object.keys(this.quarantinedQuery.sub_category).forEach(categoryKey => {
				this.quarantinedQuery.sub_category[categoryKey] = query.sub_category[categoryKey];
			});
			Object.keys(this.quarantinedQuery.category).forEach(categoryKey => {
				this.quarantinedQuery.category[categoryKey] = query.category[categoryKey];
			});
			Object.keys(this.quarantinedQuery.status).forEach(categoryKey => {
				switch (categoryKey) {
					case this.dic.CONSTANTS.quarantinedActions.remove.value:
						categoryKey = 'removed';
						break;

					case this.dic.CONSTANTS.quarantinedActions.release.value:
						categoryKey = 'released';
						break;
				}

				this.quarantinedQuery.status[_.capitalize(categoryKey)] = query.status[_.capitalize(categoryKey)];
			});
		}

		if (this.displayViewAllPlansBtn) {
			this.viewPlanList = _.cloneDeep(this.gs.planAdmins);

			if (query.selectedPlans[0] === 'onlyMyPlan' || query.selectedPlans[0] === 'all') {
				this.selectViewPlan(query.selectedPlans[0]);
			}
			else {
				this.viewPlanList.forEach(plan => plan.selected = false);
				query.selectedPlans.forEach(planDisplayEmail => {
					const planObj = _.find(this.viewPlanList, {display_email: planDisplayEmail});
					this.selectViewPlan(planObj);
				});
			}
		}

		// extra check if source can be other than Trustifi during loading time
		if (!this.isExchangeConnected || !this.powershellQuarantineEnabled) {
			this.quarantinedQuery.source = this.emailsSources.trustifi;
		}
		this.calculateQueryDisplay();
	}

	restoreQuarantinedQueryFromLocalStorage = () => {
		// check previous query from localStorage and retrieve it
		let previousQuery;
		const userSpecificKey = `quarantinedQuery_${this.userInfo?.email}_${this.userInfo?.plan?._id?.toString()}`;

		try { // "try" in case the parameters won't parse correctly
			previousQuery = JSON.parse(localStorage[userSpecificKey]);
		}
		catch {
			return;
		}

		// if last query saved to localstorage then apply the saved query
		this.queryType = previousQuery.queryType;

		if (this.queryType === this.queryTypes.messageIdOnly) {
			this.quarantinedQuery.message_id = previousQuery.message_id;
		}
		else {
			this.resultsPeriod = previousQuery.period;
			this.range = previousQuery.range;

			this.quarantinedQuery.mailbox_email = previousQuery.mailbox_email;
			this.quarantinedQuery.sender = previousQuery.sender;
			this.quarantinedQuery.subject = previousQuery.subject;
			this.quarantinedQuery.link = previousQuery.link;
			this.quarantinedQuery.file = previousQuery.file;
			this.quarantinedQuery.source = previousQuery.source || this.emailsSources.trustifi;

			const savedCategories = (previousQuery.category || '').split(',');
			_.keys(this.quarantinedQuery.category).forEach(categoryName => {
				this.quarantinedQuery.category[categoryName] = savedCategories.includes(categoryName);
			});
			const savedSubCategories = (previousQuery.sub_category || '').split(',');
			_.keys(this.quarantinedQuery.sub_category).forEach(subCategoryName => {
				this.quarantinedQuery.sub_category[subCategoryName] = savedSubCategories.includes(subCategoryName);
			});
			const savedStatuses = (previousQuery.status || '').split(',');
			_.keys(this.quarantinedQuery.status).forEach(statusName => {
				let formattedStatus = statusName;
				switch (formattedStatus) {
					case 'Removed':
						formattedStatus = this.dic.CONSTANTS.quarantinedActions.remove.value;
						break;

					case 'Released':
						formattedStatus = this.dic.CONSTANTS.quarantinedActions.release.value;
						break;
				}
				this.quarantinedQuery.status[statusName] = savedStatuses.includes(formattedStatus.toLowerCase());
			});
		}
	}

	getCurrentQueryModelAsTemplate = () => {
		const template:any = {};

		template.queryType = this.queryType;
		if (this.queryType === this.queryTypes.messageIdOnly) {
			template.message_id = this.quarantinedQuery.message_id;
		}
		else {
			Object.assign(template, this.getDefaultQueryObject());
			template.period = this.resultsPeriod;
			template.range = this.range;

			template.mailbox_email = this.quarantinedQuery.mailbox_email;
			template.sender = this.quarantinedQuery.sender;
			template.subject = this.quarantinedQuery.subject;
			template.link = this.quarantinedQuery.link;
			template.file = this.quarantinedQuery.file;
			template.source = this.quarantinedQuery.source || this.emailsSources.trustifi;

			Object.keys(template.category).forEach(categoryKey => {
				template.category[categoryKey] = this.quarantinedQuery.category[categoryKey];
			});
			Object.keys(template.sub_category).forEach(categoryKey => {
				template.sub_category[categoryKey] = this.quarantinedQuery.sub_category[categoryKey];
			});
			Object.keys(template.status).forEach(categoryKey => {
				switch (categoryKey) {
					case this.dic.CONSTANTS.quarantinedActions.remove.value:
						categoryKey = 'removed';
						break;

					case this.dic.CONSTANTS.quarantinedActions.release.value:
						categoryKey = 'released';
						break;
				}

				template.status[_.capitalize(categoryKey)] = this.quarantinedQuery.status[_.capitalize(categoryKey)];
			});
		}

		if (this.displayViewAllPlansBtn) {
			if (this.viewMyPlanOnly) {
				template.selectedPlans = ['onlyMyPlan'];
			}
			else if (this.viewAllPlans) {
				template.selectedPlans = ['all'];
			}
			else {
				template.selectedPlans = _.map(_.filter(this.viewPlanList, 'selected'), 'display_email')
			}
		}

		return template;
	}

    initQuarantinedQuery = () => {
        this.queryType = this.queryTypes.normal;
        this.resultsPeriod = this.dic.CONSTANTS.trendsPeriod.lastDay;
        this.range = {start: new Date(Date.now() - (1000 * 60 * 60 * 24)), end: new Date()}; // (past one day)

        this.quarantinedQuery = this.getDefaultQueryObject();
	}

	getDefaultQueryObject = () => {
		return {
			source: this.emailsSources.trustifi,
			mailbox_email: '',
			sender: '',
			subject: '',
			link: '',
			file: '',
			message_id: '',
			category: {
				Malicious: true,
				Suspicious: true,
				Spam: true,
				Graymail: true,
				External: false,
				Safe: false
			},
			sub_category: {
				Malware: false,
				Phishing: false,
				Spoofing: false,
				Impersonation: false,
				'Business Email Compromise': false,
				Spam: false,
				Graymail: false,
				'Third Party Verdict': false,
				'User Preferences': false,
				'Threat Intelligence': false,
				Blocklist: false,
				Allowlist: false,
				'Known Contact': false
			},
			status: {
				Quarantined: false,
				Released: false,
				Removed: false,
				'Requested release': false,
				'Release failure': false
			}
		};
	}

	resetQuery = () => {
		localStorage.removeItem('quarantinedQuery');
		this.initQuarantinedQuery();
		this.calculateQueryDisplay();
	};

    validateQuery = () => {
        this.queryValidationErrors = [];

        // validation for 'message ID only' query
        if (this.queryType === this.queryTypes.messageIdOnly) {
            if (!this.quarantinedQuery.message_id) {
                //this.ns.showErrorMessage(util.format(this.dic.ERRORS.accountEmailMissingName, 'Message ID'));
                this.queryValidationErrors.push('message_id');
                return false;
            }
            else {
                return true;
            }
        }
        //

        let isPassed = true;

        // period (range) check
        if (this.gs.equals(this.resultsPeriod, this.dic.CONSTANTS.trendsPeriod.range)) {
            const range:any = {
                start: this.range?.start,
                end: this.range?.end
            };
            if (!this.range?.start || !this.range?.end || range.start > Date.now() || range.start > range.end) {
                this.ns.showWarnMessage(this.dic.ERRORS.adminQuarantinedDate);
                isPassed = false;
            }
        }
        // category check
        const categoriesForSearch = this.getCategoriesForQuery();
        if (!categoriesForSearch) {
            // this.ns.showErrorMessage(this.dic.ERRORS.quarantinedCategoryMissing);
            this.queryValidationErrors.push('category');
            isPassed = false;
        }

        return isPassed;
    }

	getQuarantinedEmailsQuickAction = () => {
		if (this.getEmailsInProcess || !this.validateQuery()) {
			return;
		}

		const categoriesToEnable = Object.keys(this.quarantinedQuery.category).filter(category => {
			const ruleKey = category.toLowerCase();
			return this.rules?.[ruleKey]?.actions?.includes(this.dic.CONSTANTS.tpRule.action.quarantine);
		});

		Object.keys(this.quarantinedQuery.status).forEach(status => {
			this.quarantinedQuery.status[status] = status === 'Quarantined';
		});

		Object.keys(this.quarantinedQuery.category).forEach(category => {
			this.quarantinedQuery.category[category] = categoriesToEnable.includes(category);
		});
		this.quarantinedQuery.category['Malicious'] = true;
		this.tableQueryTemplatesService.isSomeValueChanged = true;

		this.applyQuery();

		setTimeout(() => {
			this.initFilters();

			const updateFilterData = [
				{key: 'status', option: 'Quarantined', newValue: true},
				...categoriesToEnable.map(cat => ({key: 'category', option: cat, newValue: true}))
			];

			this.quarantinedTable.updateFilterOptions(updateFilterData);
		});
	}

	getReportedEmailsQuickAction = () => {
		if (this.getEmailsInProcess || !this.validateQuery()) {
			return;
		}

		this.applyQuery();

		this.initFilters();

		const updateFilterData = [
			{
				key: 'reported by',
				option: 'Reviewer',
				newValue: true
			},
			{
				key: 'reported by',
				option: 'Recipient',
				newValue: true
			},
			{
				key: 'reported by',
				option: 'Third party',
				newValue: true
			},
		];

		this.quarantinedTable.updateFilterOptions(updateFilterData);
	}

	getRequestReleaseEmailsQuickAction = () => {
		if (this.getEmailsInProcess || !this.validateQuery()) {
			return;
		}

		this.applyQuery();

		this.initFilters();

		const updateFilterData = [{
			key: 'status',
			option: 'Requested release',
			newValue: true
		}];

		this.quarantinedTable.updateFilterOptions(updateFilterData);
	}

	// CC: taken from inbound-quarantined.component.ts -> getQuarantinedEmailsQuickAction
	getImportantEmailsQuickAction = () => {
		if (this.getEmailsInProcess) {
			return;
		}

		// CC: the important flag is only sent by a regular Trustifi query, a leftover message ID query or the Exchange source would drop it
		this.queryType = this.queryTypes.normal;
		this.quarantinedQuery.source = this.emailsSources.trustifi;
		if (!this.validateQuery()) {
			return;
		}

		// CC: important emails include release requests that still wait for a reviewer decision
		const importantStatuses = ['Quarantined', 'Requested release'];
		Object.keys(this.quarantinedQuery.status).forEach(status => {
			this.quarantinedQuery.status[status] = importantStatuses.includes(status);
		});
		this.tableQueryTemplatesService.isSomeValueChanged = true;

		// CC: the flag lives only during this applyQuery call so no other query inherits it
		this.isImportantQuery = true;
		this.applyQuery();
		this.isImportantQuery = false;

		// CC: filter-table-c rebuilds its options only after change detection passes it the new filterData, updating before that hits the stale options and leaves old filters applied
		this.initFilters();
		setTimeout(() => {
			this.quarantinedTable?.updateFilterOptions(importantStatuses.map(status => ({key: 'status', option: status, newValue: true})));
		});
	}

	selectViewPlan = (plan) => {
		// Reset view flags initially: start with both flags set to false
		this.viewMyPlanOnly = this.viewAllPlans = false;

		// Helper function to set selection status for all plans
		const toggleSelection = (status) => {
			this.viewPlanList.forEach(p => p.selected = status);
		};

		switch (plan) {
			case 'all':
				// Determine if we need to select or deselect all plans
				const selectAll = !this.viewPlanList.every(p => p.selected);
				toggleSelection(selectAll);
				this.viewAllPlans = selectAll;

				// If all plans are deselected, select only the first plan and set viewMyPlanOnly flag
				if (!selectAll) {
					this.viewPlanList[0].selected = true;
					this.viewMyPlanOnly = true;
				}
				break;

			case 'onlyMyPlan':
				// Deselect all plans first
				toggleSelection(false);
				// Then select only the first plan and set viewMyPlanOnly flag
				this.viewPlanList[0].selected = true;
				this.viewMyPlanOnly = true;
				break;

			default:
				// Toggle the selection status of the specific plan
				plan.selected = !plan.selected;

				// If no plans are selected, default to selecting the first plan and set viewMyPlanOnly flag
				if (!this.viewPlanList.some(p => p.selected)) {
					this.viewPlanList[0].selected = true;
					this.viewMyPlanOnly = true;
				} else {
					// Check if only the first plan is selected to update viewMyPlanOnly
					this.viewMyPlanOnly = this.viewPlanList[0].selected && this.viewPlanList.slice(1).every(p => !p.selected);

					// Check if all plans are selected to update viewAllPlans
					this.viewAllPlans = this.viewPlanList.every(p => p.selected);
				}
				break;
		}

		this.tableQueryTemplatesService.isSomeValueChanged = true;
	};


	selectMainSource = (selectedSource) => {
		if (selectedSource === this.emailsSources.exchange && !this.powershellQuarantineEnabled) {
			this.gs.showPopup({
				title: 'Microsoft Exchange Quarantine',
				subTitle: 'Note: Synchronization with Exchange not enabled',
				body: ['To pull and display quarantined email data from Microsoft Exchange, you must first enable the PowerShell integration and the "Synchronize Exchange Server Quarantined Emails" setting'],
				type: this.dic.CONSTANTS.popupWarning,
				doneBtnText: 'Go to integrations page',
				doneCb: () => {
					this.router.navigate([this.dic.CONSTANTS.appStates.adminInbound, this.dic.CONSTANTS.adminPages.inbound.plan, this.dic.CONSTANTS.inboundPlanSettingsPageTabs.integrations], {state: {integrationType: this.dic.CONSTANTS.integrationType.powershell}});
				}
			});
			return;
		}

		this.quarantinedQuery.source = selectedSource;
		this.tableQueryTemplatesService.isSomeValueChanged = true;
	}

    // 1. send query to validation. 2. create query string for query box
    applyQuery = () => {
        if (!this.validateQuery()) {
			if (this.reviewerInfo?.is_security_reviewer && !this.quarantinedViewNeedsPlanSelection) {
				this.securityReviewerWeeklyReleasesInProcess = false;
			}
            return;
        }

        this.quarantinedQuery.sender = this.quarantinedQuery.sender?.toLowerCase();
        this.quarantinedQuery.mailbox_email = this.quarantinedQuery.mailbox_email?.toLowerCase();

        this.calculateQueryDisplay();

		this.currentQuery = this.getQueryForQuarantine();

        this.showQueryModal = false;
        this.isQueryError = false;

        this.getQuarantinedEmails();
    }

	setQueryFromOutside = () => {
		// predefined message-id-based query
		const urlQuery = new URLSearchParams(location.search.substring(1) || '');
		let message_id = urlQuery.get('message_id') || window.history.state.quarantinedMessageId;
		if (message_id) {
			// Replace all white spaces with '+'
			message_id = message_id.replace(/\s+/g, '+');
			this.queryType = this.queryTypes.messageIdOnly;
			this.quarantinedQuery.message_id = message_id;
			return true;
		}

		// predefined query from WA
		if (window.history.state.data) {
			this.resultsPeriod = window.history.state.data.period || this.dic.CONSTANTS.trendsPeriod.lastWeek;
			this.range = window.history.state.data.range || this.range;
			this.quarantinedQuery.mailbox_email = window.history.state.data.mailbox || this.quarantinedQuery.mailbox_email;
			this.quarantinedQuery.sender = window.history.state.data.sender || '';
			this.quarantinedQuery.subject = window.history.state.data.subject || '';
			this.quarantinedQuery.link = window.history.state.data.link || '';
			this.quarantinedQuery.file = window.history.state.data.file || '';

			if (window.history.state.data.category?.length) {
				initializeValues(this.quarantinedQuery.category);
				window.history.state.data.category.forEach((category) => {
					this.quarantinedQuery.category[category] = true;
				});
			}

			if (window.history.state.data.sub_category?.length) {
				initializeValues(this.quarantinedQuery.sub_category);
				window.history.state.data.sub_category.forEach((sub_category) => {
					this.quarantinedQuery.sub_category[sub_category] = true;
				});
			}

			if (window.history.state.data.status?.length) {
				initializeValues(this.quarantinedQuery.st);
				window.history.state.data.status.forEach((status) => {
					this.quarantinedQuery.status[status] = true;
				});
			}

			if (window.history.state.data.viewAllPlans) {
				this.selectViewPlan('all');
			}

			return true;
		}
	}

    // determine how query properties look in the UI, in the query box
    calculateQueryDisplay = () => {
		this.quarantinedQueryDisplay = [
			{
				title: this.resultsPeriod.display,
				tooltip: this.resultsPeriod === this.dic.CONSTANTS.trendsPeriod.range ? 'From ' + this.range.start + ' until ' + this.range.end : this.resultsPeriod.display
			},
			..._.map(this.quarantinedQuery, (value, key: string) => {
				const formattedKey = key.replace('_', ' ').replace('id', 'ID');

				let truthyValuesList;
				if (['category', 'status', 'sub_category'].includes(key)) {
					truthyValuesList = _.keys(_.pickBy(value)).join(', ');
				}

				return {
					title: formattedKey,
					tooltip: _.isUndefined(truthyValuesList) ? value : truthyValuesList
				}
			})
		];


		// messageId or normal query
		if (this.queryType === this.queryTypes.messageIdOnly) {
			this.quarantinedQueryDisplay = _.filter(this.quarantinedQueryDisplay, {title: 'message ID'});
		}
		else {
			this.quarantinedQueryDisplay = _.reject(this.quarantinedQueryDisplay, {title: 'message ID'});
		}

		// CC: without this chip an important query looks the same as a regular one in the query box
		if (this.isImportantQuery) {
			this.quarantinedQueryDisplay.unshift({title: 'Important', tooltip: 'Unreviewed quarantined emails and release requests with notable threat indicators, or from known contacts'});
		}

		// clean empty parameters
		this.quarantinedQueryDisplay = _.filter(this.quarantinedQueryDisplay, parameter => !!parameter && !_.isEmpty(parameter.tooltip));
    }

    getQueryForQuarantine = () => {
        if (this.queryType ===  this.queryTypes.messageIdOnly) {
            return {
                message_id: this.quarantinedQuery.message_id || '',
				source: this.quarantinedQuery.source || this.emailsSources.trustifi,
				size: this.dic.CONSTANTS.quarantinedEmailsFirstBatchSize,
			}
        }
        else {
			const query: any = {
				size: this.dic.CONSTANTS.quarantinedEmailsFirstBatchSize,
				period: this.resultsPeriod.value,
				category: this.getCategoriesForQuery(),
				status: this.getStatusForQuery(),
				sub_category: this.getSubCategoryForQuery(),
				mailbox_email: this.quarantinedQuery.mailbox_email?.trim() || '',
				sender: this.quarantinedQuery.sender?.trim() || '',
				subject: this.quarantinedQuery.subject?.trim() || '',
				link: this.quarantinedQuery.link?.trim() || '',
				file: this.quarantinedQuery.file?.trim() || '',
				source: this.quarantinedQuery.source || this.emailsSources.trustifi
			};

			if (this.resultsPeriod.value === this.dic.CONSTANTS.trendsPeriod.range.value) {
				query.range = this.range;
			}

			if (this.isImportantQuery) {
				query.important = true;
			}

            return query;
        }
    }

    getQuarantinedEmails = () => {
        if (this.getEmailsInProcess) {
            return;
        }

        this.groupEmails = [];
		this.selectionReviewQueue = [];

		if (this.viewAllPlans) {
			this.currentQuery.allPlans = true;
		} else if (!this.viewMyPlanOnly && this.viewPlanList) {
			this.currentQuery.view_plans = this.viewPlanList.filter(p => p.selected).map(p => p.alloc_plan_id?._id.toString());
		}

        this.getEmailsInProcess = true;

		if (this.reviewerInfo?.is_security_reviewer && !this.quarantinedViewNeedsPlanSelection) {
			this.securityReviewerWeeklyReleasesInProcess = true;
		}

		switch (this.currentQuery.source) {
			case this.emailsSources.trustifi:
				this.batchesCounter = 0;

				this.rs.getQuarantinedEmails(this.currentQuery).then((quarantineInfo) => {
					this.batchesCounter++;
					this.emails = quarantineInfo.emails || [];
					this.prepareEmails(quarantineInfo.emails);
					this.showAbortLoadingEmailsLabel = true;

					this.getNextEmailsBatch(quarantineInfo, () => {
						this.getEmailsInProcess = false;
						this.showAbortLoadingEmailsLabel = false;
						this.updateSecurityReviewerWeeklyStatsFromLoadedEmails();
					});
				}, (err) => {
					this.getEmailsInProcess = false;
					this.updateSecurityReviewerWeeklyStatsFromLoadedEmails();
				});
				break;

			case this.emailsSources.exchange:
				this.ns.showInfoMessage('Fetching email data from Exchange, this action could take some time');
				this.rs.exchangeGetQuarantinedEmails(this.currentQuery).then(data => {
					this.emails = data.emails || [];
					this.prepareEmails(data.emails);

					this.getEmailsInProcess = false;
					this.updateSecurityReviewerWeeklyStatsFromLoadedEmails();
				}, () => {
					this.getEmailsInProcess = false;
					this.updateSecurityReviewerWeeklyStatsFromLoadedEmails();
				});
		}
    };

    getNextEmailsBatch = (quarantineInfo, cb) => {
        if (!quarantineInfo.lastCreated) {
            return cb();
        }

        if (this.abortLoadingFlag) {
            this.abortLoadingFlag = false;
			return;
        }

        this.batchesCounter++;

        this.currentQuery.size = this.dic.CONSTANTS.quarantinedEmailsBatchSize;
        this.currentQuery.lastCreated = quarantineInfo.lastCreated;

        this.rs.getQuarantinedEmails(this.currentQuery).then((quarantineInfo) => {
            if (quarantineInfo.emails && quarantineInfo.emails.length) {
                this.emails = this.emails.concat(quarantineInfo.emails);
                this.prepareEmails(quarantineInfo.emails);
            }

            this.getNextEmailsBatch(quarantineInfo, cb);
        });
    }

    autoRefreshExecute = () => {
        // if emails are in process then do not auto refresh yet
        if (this.getEmailsInProcess || this.currentQuery.source === this.emailsSources.exchange) {
            return true;
        }

        delete this.currentQuery.lastCreated;
        if (this.emails?.length && !this.currentQuery.firstCreated) {
            this.currentQuery.firstCreated = this.emails[0].created;
        }
        this.rs.getQuarantinedEmails(this.currentQuery).then((quarantineInfo) => {
            if (quarantineInfo.emails?.length) {
                this.currentQuery.firstCreated = quarantineInfo.emails[0].created;

                this.emails = this.emails.concat(quarantineInfo.emails);
                this.prepareEmails(quarantineInfo.emails);
            }
			this.updateSecurityReviewerWeeklyStatsFromLoadedEmails();
        });
    }

    abortLoadingEmails = () => {
        this.abortLoadingFlag = true;
        this.getEmailsInProcess = false;
        this.showAbortLoadingEmailsLabel = false;
		this.updateSecurityReviewerWeeklyStatsFromLoadedEmails();
    }

    prepareEmails = (emails) => {
		if (!emails || !emails.length) return;
        _.each(emails, email => {
            this.calculateTags(email);
            this.setEmailCategory(email);
        });
		this.prepareEmailGroups();
    }

    initAutoRefresh = (interval) => {
        switch (interval) {
            case 'Every 30 Seconds':
                this.activeAutoRefreshLoop = setInterval(() => {
                    this.autoRefreshExecute();
                }, 30000);
                break;

            case 'Every 60 Seconds':
                this.activeAutoRefreshLoop = setInterval(() => {
                    this.autoRefreshExecute();
                }, 60000);
                break;

            case 'Off':
                clearInterval(this.activeAutoRefreshLoop);
                this.activeAutoRefreshLoop = null;
                break;
        }

		this.autoRefreshMenuData.items.forEach((intervalMenuItem) => {
			intervalMenuItem.isActive = intervalMenuItem.label === interval;
		});
		this.autoRefreshMenuData.isActive = interval !== 'Off';
		this.autoRefreshMenuData.tooltip = `Refresh data automatically${interval !== 'Off' ? ' - ' + interval.toLowerCase() : ''}`;
    }

	prepareEmailGroups = () => {
		if (!this.emails?.length) {
			this.groupEmails = [];
			return;
		}

		const groupedEmails = this.groupBySender
			? _.groupBy(this.emails, (emailObj) => emailObj.sender || 'None')
			: this.currentQuery.source === this.emailsSources.trustifi ? _.groupBy(this.emails, 'message_id') : _.groupBy(this.emails, '_id');

		let count = 0;
		const groupEmailsArr = [];

		Object.keys(groupedEmails).forEach((groupKey) => {
			const emailsGroup = groupedEmails[groupKey];
			let parentEmailGroup = this.groupBySender ? null : this.isEmailParentExist(emailsGroup[0], groupEmailsArr);

			if (!parentEmailGroup) {
				parentEmailGroup = {mailbox_email: [], emails: [], parent: true, _id: ++count, reviewed_completed: false};
				groupEmailsArr.push(parentEmailGroup);
			}

			emailsGroup.forEach((emailObj) => {
				emailObj.parent_id = parentEmailGroup._id;
				parentEmailGroup.emails.push(emailObj);
				parentEmailGroup.mailbox_email.push(emailObj.mailbox_email);
				if (emailObj.auth_sender && emailObj.auth_sender.status) {
					parentEmailGroup.auth_sender = emailObj.auth_sender;
				}
				parentEmailGroup.reviewed_completed = parentEmailGroup.reviewed_completed || emailObj.reviewed_completed;
			});

			this.populateParentEmailGroup(parentEmailGroup);
			parentEmailGroup.visibleEmailsCount = parentEmailGroup.emails.length;
		});

		// CC: in groups with more than one email every son is selectable (and counted) on its own, and the main record selects all of its sons as a whole
		groupEmailsArr.forEach((parentEmailGroup) => {
			const isMultipleEmailsGroup = parentEmailGroup.emails.length > 1;
			parentEmailGroup.isSubRecordsSelector = isMultipleEmailsGroup;
			parentEmailGroup.emails.forEach((emailObj) => {
				emailObj.isSelectable = isMultipleEmailsGroup;
				emailObj.selected = false;
			});
		});

		this.groupEmails = groupEmailsArr;
		this.saveQueryToLocalStorage();
	}

	populateParentEmailGroup = (parentEmailGroup) => {
		if (!parentEmailGroup.emails?.length) {
			return;
		}

		parentEmailGroup.created = parentEmailGroup.emails[0].created;
		parentEmailGroup.subject = parentEmailGroup.emails[0].subject;
		parentEmailGroup.source = parentEmailGroup.emails[0].source;
		parentEmailGroup.sender = parentEmailGroup.emails[0].sender;
		parentEmailGroup.attachments = parentEmailGroup.emails[0].attachments;
		parentEmailGroup.links = parentEmailGroup.emails[0].links;
		parentEmailGroup.message_id = parentEmailGroup.emails[0].message_id;
		parentEmailGroup.plan_id = parentEmailGroup.emails[0].plan_id;
		parentEmailGroup.mailbox_email = _.uniq(parentEmailGroup.mailbox_email);

		parentEmailGroup.reviewed_completed = parentEmailGroup.emails.some((emailObj) => emailObj.reviewed_completed);
		parentEmailGroup.auth_sender = parentEmailGroup.auth_sender || parentEmailGroup.emails.find((emailObj) => emailObj.auth_sender?.status)?.auth_sender;

		calcParentEmailCategory(parentEmailGroup);
		this.calculateTags(parentEmailGroup);
	}

	toggleGroupBySender = () => {
		this.groupBySender = !this.groupBySender;
		this.doNotChangeIsExpandedStates = false;
		this.prepareEmailGroups();
		this.quarantinedTable?.searchItem();
	}


	isEmailParentExist = (emailObj, list) => {
		if (emailObj.source === this.emailsSources.exchange) {
			return false;
		}
        return list.find(itm => itm.message_id === emailObj.message_id || (
            itm.sender === emailObj.sender && itm.subject === emailObj.subject
            && diffMinutes(itm.created, emailObj.created) < 3
        ));
    }

	saveQueryToLocalStorage() {
		try {
			const paramsToLocalStorage = _.clone(this.currentQuery);
			paramsToLocalStorage['queryType'] = this.queryType;
			paramsToLocalStorage['period'] = this.resultsPeriod; // (the already existed 'period' property in 'params' is only the value, not the desired period object)
			const userSpecificKey = `quarantinedQuery_${this.userInfo?.email}_${this.userInfo?.plan?._id?.toString()}`;
			localStorage[userSpecificKey] = JSON.stringify(paramsToLocalStorage); // Object
		}
		catch (err) {
			console.error(err);
		}

	}

    changePeriod = (period) => {
        this.resultsPeriod = period;
		this.tableQueryTemplatesService.isSomeValueChanged = true;
    };

    getCategoriesForQuery:any = () => {
        let categoriesForSearch = [];
        for (let category in this.quarantinedQuery.category) {
            if (this.quarantinedQuery.category[category]) {
                categoriesForSearch.push(category);
            }
        }

        return categoriesForSearch.join(',');
    }

	getStatusForQuery:any = () => {
		let statusForSearch = [];
		for (let status in this.quarantinedQuery.status) {
			if (this.quarantinedQuery.status[status]) {
				switch (status) {
					case 'Quarantined':
						statusForSearch.push(this.dic.CONSTANTS.quarantinedActions.quarantine.value);
						break;

					case 'Released':
						statusForSearch.push(this.dic.CONSTANTS.quarantinedActions.release.value);
						break;

					case 'Removed':
						statusForSearch.push(this.dic.CONSTANTS.quarantinedActions.remove.value);
						break;

					case 'Requested release':
						statusForSearch.push(this.dic.CONSTANTS.quarantinedActions.requestRelease.value);
						break;

					case 'Release failure':
						statusForSearch.push(this.dic.CONSTANTS.quarantinedActions.releaseFailure.value);
						break;
				}
			}
		}

		return statusForSearch.join(',');
	}

	getSubCategoryForQuery:any = () => {
		let subCategoriesForSearch = [];
		for (let category in this.quarantinedQuery.sub_category) {
			if (this.quarantinedQuery.sub_category[category]) {
				subCategoriesForSearch.push(category);
			}
		}

		return subCategoriesForSearch.join(',');
	}

    isDeleteActionAllowed = () => {
        return this.userInfo.user_role === this.dic.CONSTANTS.userRole.admin ||
            this.userInfo.user_role === this.dic.CONSTANTS.userRole.subAdmin;
    }

	showMultipleQuarantinedActions = () => {
		if (this.currentQuery.source === this.emailsSources.trustifi) {
			return _.compact([
				this.dic.CONSTANTS.quarantinedActions.viewInfo.display,
				this.dic.CONSTANTS.quarantinedActions.release.display,
				this.dic.CONSTANTS.quarantinedActions.remove.display,
				this.dic.CONSTANTS.quarantinedActions.setCategory.display,
				this.dic.CONSTANTS.quarantinedActions.trustSender.display,
				this.dic.CONSTANTS.quarantinedActions.blacklist.display,

				{
					display: this.dic.CONSTANTS.quarantinedActions.toggleKeepForever.display,
					submenu: [
						{value: 'enableToggleKeepForever', display: 'Enable'},
						{value: 'disableToggleKeepForever', display: 'Disable'}
					]
				},
				this.dic.CONSTANTS.quarantinedActions.handled.display,
				this.isDeleteActionAllowed() && this.dic.CONSTANTS.quarantinedActions.delete.display,
			]);
		}
		else if (this.currentQuery.source === this.emailsSources.exchange) {
			return _.compact([
				this.dic.CONSTANTS.quarantinedActions.release.display,
				this.dic.CONSTANTS.quarantinedActions.remove.display
			]);
		}
	}

    showQuarantinedActions = (emailObj) => {
		if (emailObj.source === this.emailsSources.exchange) {
			const exchangeActions = [
				this.dic.CONSTANTS.quarantinedActions.release.display,
				this.allowReviewerShowContent && this.dic.CONSTANTS.quarantinedActions.eml.display
			];
			if (emailObj.status === this.dic.CONSTANTS.quarantinedActions.release.value) {
				exchangeActions.push(this.dic.CONSTANTS.quarantinedActions.remove.display);
			}
			return _.compact(exchangeActions);
		}

		const actions = [
			this.dic.CONSTANTS.quarantinedActions.viewInfo.display,
			this.dic.CONSTANTS.quarantinedActions.release.display,
			this.dic.CONSTANTS.quarantinedActions.setCategory.display,
			this.dic.CONSTANTS.quarantinedActions.trustSender.display,
		];

		if (this.isDeleteActionAllowed()) {
			actions.push(this.dic.CONSTANTS.quarantinedActions.delete.display);
		}

		if (this.allowReviewerShowContent) {
			actions.push(this.dic.CONSTANTS.quarantinedActions.eml.display);
		}

		switch (emailObj.status) {
			case this.dic.CONSTANTS.quarantinedActions.releaseFailure.value:
			case this.dic.CONSTANTS.quarantinedActions.release.value:
				actions.push(this.dic.CONSTANTS.quarantinedActions.remove.display);
				break;
		}

		if (this.quarantinedQuery.source === this.emailsSources.trustifi) {
			actions.push(emailObj.keep_forever ? 'Do not preserve record' : 'Preserve record');
		}

		return actions;
	};

    selectAction = (email, action, keepSelectionReview = false) => {
		if (!keepSelectionReview) {
			this.selectionReviewQueue = [];
		}
        const resolvedEmail = this.resolveSingleVisibleChild(email);
        this.quarantinedEmailAction = {
			action: action,
			email: resolvedEmail,
			data: {
				source: this.quarantinedQuery?.source
			},
		};
		if (action === this.dic.CONSTANTS.quarantinedActions.viewInfo.display) {
			this.refreshThreatNavigationEmails(resolvedEmail);
		}
    };

	// clicking an Email Activity row opens its Threat Analysis (the checkbox cell still selects it); Exchange records have no threat analysis
	openThreatAnalysisFromRow = (email) => {
		// CC: the table toggles the selection on any row click before emitting - undo it so only the checkbox cell selects (re-emits with isItemSelectCheckboxClicked, which the template ignores)
		if (this.quarantinedTable.isItemSelectable(email)) {
			email.selected = !email.selected;
			this.quarantinedTable.selectItem(email, true);
		}

		if (email?.source === this.emailsSources.exchange) {
			return;
		}
		this.selectAction(email, this.dic.CONSTANTS.quarantinedActions.viewInfo.display);
	};

	// A filtered-down group can look like a single email row while still being the parent record underneath - resolve it to the real child so actions target just that email
	resolveSingleVisibleChild = (email) => {
		const visibleChildren = email?.parent ? email.emails?.filter(childEmail => !childEmail.hide) : null;
		return visibleChildren?.length === 1 ? visibleChildren[0] : email;
	};

    selectMultipleEmailsAction = (selectedItems, action) => {
		if (action === this.dic.CONSTANTS.quarantinedActions.viewInfo.display) {
			// one stop per selected email (a group contributes only its selected emails), so actions never reach unselected group members
			this.selectionReviewQueue = _.uniqBy(selectedItems.filter((item) => item?._id), '_id');
			if (this.selectionReviewQueue.length) {
				this.selectAction(this.selectionReviewQueue[0], action, true);
			}
			return;
		}

        let childAction = action;
        if (action?.value === 'enableToggleKeepForever') {
            childAction = 'Preserve record';
        }
        if (action?.value === 'disableToggleKeepForever') {
            childAction = 'Do not preserve record';
        }

		this.quarantinedEmailAction = {
			action: childAction,
			data: {
				source: this.quarantinedQuery?.source,
				emails: selectedItems
			},
		};
    };

	onQuarantinedActionDone = (event) => {
		switch (event.action) {
			case this.dic.CONSTANTS.quarantinedActions.release.value:
				if (event.email?.status === this.dic.CONSTANTS.quarantinedActions.pending.value) {
					this.addQuarantineStatusCheck(event.email);
				}
				break;

			case this.dic.CONSTANTS.quarantinedActions.delete.value:
				_.remove<any>(this.selectionReviewQueue, queuedEmail => _.some(event.emails, {_id: queuedEmail._id}));
				const touchedParentGroups = [];
				event.emails?.forEach((email) => {
					if (email.parent) {
						_.remove<any>(this.groupEmails, {_id: email._id});
					}
					else {
						_.remove<any>(this.emails, {_id: email._id});
						// CC: sons are now deleted on their own (bulk select), so remove them from their group and drop the group when it is left empty
						const parentEmailGroup = _.find<any>(this.groupEmails, {_id: email.parent_id});
						if (parentEmailGroup) {
							_.remove<any>(parentEmailGroup.emails, {_id: email._id});
							if (!parentEmailGroup.emails.length) {
								_.remove<any>(this.groupEmails, {_id: parentEmailGroup._id});
							}
							else if (!touchedParentGroups.includes(parentEmailGroup)) {
								touchedParentGroups.push(parentEmailGroup);
							}
						}
					}
				});
				if (touchedParentGroups.length) {
					touchedParentGroups.forEach((parentEmailGroup: any) => {
						const isMultipleEmailsGroup = parentEmailGroup.emails.length > 1;
						parentEmailGroup.isSubRecordsSelector = isMultipleEmailsGroup;
						parentEmailGroup.emails.forEach((emailObj) => {
							emailObj.isSelectable = isMultipleEmailsGroup;
						});
					});
					// a surviving group keeps the same array reference in groupEmails, so the table's differ won't auto-refresh on its own - force the search/filter recompute
					this.quarantinedTable?.searchItem();
				}
				break;

			case 'releaseDeleteRecord':
				_.remove<any>(this.groupEmails, emailObj => emailObj._id === event.email._id);
				_.remove<any>(this.selectionReviewQueue, queuedEmail => queuedEmail._id === event.email._id);
				break;

			case 'markGroupParentReviewed':
				const parentEmail = _.find<any>(this.groupEmails, {_id: event.email.parent_id});
				if (parentEmail) {
					parentEmail.reviewed_completed = true;
				}
				break;
		}
	};


	getThreatNavigationSourceEmails = () => {
		if (this.selectionReviewQueue.length) {
			return this.selectionReviewQueue;
		}

		const parents = this.quarantinedTable?.dataList?.length
			? this.quarantinedTable.dataList.filter((item: any) => {
				const isTopLevel = item.depthLevel === 0 || _.isNil(item.depthLevel);
				return isTopLevel && !item.hide;
			})
			: (this.groupEmails || []).filter((item) => !item?.hide);

		const flattenedEmails = [];
		const seenKeys = new Set();

		parents.forEach((parent) => {
			// CC: one nav stop per parent group — keep the parent object so Set Category / release use the group path
			if (parent?.parent && parent?.emails?.length) {
				const firstChild = parent.emails.find((child) => child && !child.hide);
				if (!firstChild) {
					return;
				}

				const key = firstChild._id || firstChild.id;
				if (!key || seenKeys.has(key)) {
					return;
				}

				seenKeys.add(key);
				flattenedEmails.push(parent);
				return;
			}

			if (parent?.parent_id) {
				return;
			}

			const key = parent?._id || parent?.id;
			if (!key || seenKeys.has(key)) {
				return;
			}

			seenKeys.add(key);
			flattenedEmails.push(parent);
		});

		return flattenedEmails;
	};

	findThreatNavigationParentGroup = (item) => {
		if (!item) {
			return null;
		}

		if (item.parent && item.emails?.length) {
			return item;
		}

		if (!item.parent_id) {
			return null;
		}

		const sourceLists = [
			this.quarantinedTable?.dataList,
			this.groupEmails
		];

		for (const list of sourceLists) {
			if (!list?.length) {
				continue;
			}

			const parentGroup = list.find((record: any) => record?.parent && record._id === item.parent_id);
			if (parentGroup) {
				return parentGroup;
			}
		}

		return null;
	};

	refreshThreatNavigationEmails = (email?) => {
		const targetEmail = email || this.quarantinedEmailAction?.email;
		const getNavigationKey = (item) => {
			if (!item) {
				return null;
			}

			if (item.parent && item.emails?.length) {
				const firstVisibleChild = item.emails.find((child) => child && !child.hide) || item.emails[0];
				return firstVisibleChild?._id || item._id || null;
			}

			return item._id || item.id || item.mailbox_email || item.subject || null;
		};

		// CC: map any child in a group to the parent so arrow nav matches table-open (parent path for actions)
		const resolveNavigableEmail = (item) => {
			const parentGroup = this.findThreatNavigationParentGroup(item);
			if (parentGroup?.emails?.length) {
				return parentGroup;
			}

			return item;
		};

		this.threatNavigationEmails = _.chain(this.getThreatNavigationSourceEmails() || [])
			.filter((item) => !!getNavigationKey(item))
			.uniqBy((item) => getNavigationKey(item))
			.value();

		if (targetEmail) {
			const resolvedTarget = this.selectionReviewQueue.length ? targetEmail : resolveNavigableEmail(targetEmail);
			const targetKey = getNavigationKey(resolvedTarget);
			let targetIndex = this.threatNavigationEmails.findIndex((item) => getNavigationKey(item) === targetKey);
			if (targetIndex === -1 && resolvedTarget && targetKey) {
				this.threatNavigationEmails = [...this.threatNavigationEmails, resolvedTarget];
				targetIndex = this.threatNavigationEmails.length - 1;
			}
			this.currentThreatNavigationIndex = targetIndex;
		}
		else {
			this.currentThreatNavigationIndex = this.threatNavigationEmails.length ? 0 : -1;
		}

		if (this.currentThreatNavigationIndex === -1 && this.threatNavigationEmails.length) {
			this.currentThreatNavigationIndex = 0;
		}
	};

	canNavigateThreatPrev = () => {
		if (!this.quarantinedEmailAction?.action || this.quarantinedEmailAction.action !== this.dic.CONSTANTS.quarantinedActions.viewInfo.display) {
			return false;
		}

		return this.threatNavigationEmails.length > 1 && this.currentThreatNavigationIndex > 0;
	};

	canNavigateThreatNext = () => {
		if (!this.quarantinedEmailAction?.action || this.quarantinedEmailAction.action !== this.dic.CONSTANTS.quarantinedActions.viewInfo.display) {
			return false;
		}

		return this.threatNavigationEmails.length > 1 && this.currentThreatNavigationIndex > -1 && this.currentThreatNavigationIndex < this.threatNavigationEmails.length - 1;
	};

	navigateThreatAnalysisEmail = (direction: number, event?: Event) => {
		if (event) {
			event.preventDefault();
			event.stopPropagation();
		}

		if (!this.quarantinedEmailAction?.action || this.quarantinedEmailAction.action !== this.dic.CONSTANTS.quarantinedActions.viewInfo.display) {
			return;
		}

		this.refreshThreatNavigationEmails();

		if (!this.threatNavigationEmails.length || this.currentThreatNavigationIndex === -1) {
			return;
		}

		const targetIndex = this.currentThreatNavigationIndex + direction;

		if (targetIndex < 0 || targetIndex >= this.threatNavigationEmails.length) {
			return;
		}

		const nextEmail = this.threatNavigationEmails[targetIndex];

		if (!nextEmail) {
			return;
		}

		this.currentThreatNavigationIndex = targetIndex;
		this.quarantinedEmailAction = {
			action: this.dic.CONSTANTS.quarantinedActions.viewInfo.display,
			email: this.resolveSingleVisibleChild(nextEmail),
			data: this.quarantinedEmailAction?.data
		};
	};

    copyItemToClipboard = (item) => {
        this.clipboard.copy(item);
    };

	viewEmailFromSender = (sender) => {
		this.gs.showPopup({
			title: `View other emails from this sender`,
			body: [`Review the quarantined email records from sender ${sender} for the past month.`,
				"This action will close the current window."],
			type: this.dic.CONSTANTS.popupInfo,
			doneBtnText: 'Confirm',
			doneCb: () => {
				this.quarantinedEmailAction = null;
				this.selectionReviewQueue = [];
				this.initQuarantinedQuery();
				this.quarantinedQuery.sender = sender;
				this.resultsPeriod = this.dic.CONSTANTS.trendsPeriod.lastMonth;
				this.calculateQueryDisplay();
				this.applyQuery();
			}
		});
	}

    setInboundStatusStyles = (status) => {
        switch (status) {
            case this.dic.CONSTANTS.threatProtection.status.malicious:
                return {color: 'darkred', icon: 'fa-bug', loading: false};

            case this.dic.CONSTANTS.threatProtection.status.suspicious:
                return {color: 'darkred', icon: 'fa-bug', loading: false};

            case this.dic.CONSTANTS.threatProtection.status.error:
                return {color: 'darkred', icon: 'fa-exclamation-circle', loading: false};

            case this.dic.CONSTANTS.threatProtection.status.spam:
                return {color: 'darkorange', icon: 'fa-exclamation-circle', loading: false};

            case this.dic.CONSTANTS.threatProtection.status.grayMail:
                return {color: 'dimgray', icon: 'fa-exclamation-circle', loading: false};

            case this.dic.CONSTANTS.threatProtection.status.unsecured:
                return {color: 'darkorange', icon: 'fa-exclamation-circle', loading: false};

            case this.dic.CONSTANTS.threatProtection.status.pending:
            case this.dic.CONSTANTS.threatProtection.status.analyzing:
            case this.dic.CONSTANTS.threatProtection.status.analyzingLinks:
                return {color: 'darkorange', icon: 'fa-clock', loading: true};

            case this.dic.CONSTANTS.threatProtection.status.safe:
                return {color: 'darkgreen', icon: 'fa-check-circle', loading: false};

            case 'External':
                return {color: 'darkorange', icon: 'fa-external-link-alt', loading: false};

            default:
                return {color: 'darkorange', icon: 'fa-exclamation-circle', loading: false};
        }
    };


    pendingQuarantines = [];
    checkStatusTimeOut;
    addQuarantineStatusCheck = (email) => {
        this.pendingQuarantines.push(email._id.toString());

        if (this.checkStatusTimeOut) {
            return;
        }

        this.checkStatusTimeOut = setTimeout(() => {
            this.checkQuarantineStatus();
        }, 30000);
    };

    checkQuarantineStatus = () => {
        const slicedArray = this.pendingQuarantines.slice(0, 30); // limit the IDs in the query
        this.rs.checkQuarantineStatus(slicedArray.join(',')).then((response) => {
            response.forEach((statusObj) => {
                if (statusObj.status !== this.dic.CONSTANTS.quarantinedActions.pending.value) {
                    for (let idx = 0; idx < this.groupEmails.length; idx++) {
                        let emailObj = _.find<any>(this.groupEmails[idx].emails, {_id: statusObj._id});
                        if (emailObj) {
                            emailObj.status = statusObj.status;

                            calcParentEmailCategory(this.groupEmails[idx]);
                            break;
                        }
                    }
                    const index = this.pendingQuarantines.indexOf(statusObj._id);
                    if (index > -1) {
                        this.pendingQuarantines.splice(index, 1);
                    }
                }
            });

            if (this.pendingQuarantines.length) {
                this.checkStatusTimeOut = setTimeout(() => {
                    this.checkQuarantineStatus();
                }, 30000);
            }
            else {
                this.checkStatusTimeOut = null;
            }
        });
    }




	searchEmail = (searchTerm, activeFilters) => {
		this.groupEmails.forEach(record => {
			if (!searchTerm && !activeFilters) {
				showAllSubMailboxes(record);
			}

			// search + filter + tag as filter
			const isFound = this.searchEmailExecute(record, searchTerm, activeFilters, null);
			if (!isFound) {
				record.hide = true;
				return;
			}

			record.hide = false;
		});

		// re-populate each visible group from its visible children only (regroup by visibility)
		this.groupEmails.forEach(record => {
			if (record.hide || !record.emails?.length) {
				return;
			}
			const visibleChildren = record.emails.filter(child => !child.hide);
			if (!visibleChildren.length) {
				return;
			}
			const allChildren = record.emails;
			// CC: handled state belongs to the whole group, so keep it from all children instead of the search-visible subset
			const isGroupHandled = allChildren.some(child => child.reviewed_completed);
			record.emails = visibleChildren;
			record.mailbox_email = visibleChildren.map(child => child.mailbox_email);
			this.populateParentEmailGroup(record);
			record.emails = allChildren;
			record.reviewed_completed = isGroupHandled;
			record.visibleEmailsCount = visibleChildren.length;
		});

		this.doNotChangeIsExpandedStates = false;
	};

	searchEmailExecute = (email, searchTerm, activeFilters, parentEmail) => {
		let generalMatchTypes = 0;
		if (searchTerm) generalMatchTypes++;
		if (activeFilters && !_.isEmpty(activeFilters)) generalMatchTypes++;
		if (this.activeTagAsFilter) generalMatchTypes++;
		let totalEmailMatch = 0;

		// search
		if (searchTerm) {
			const isSearchFound = searchTextExecute(email, searchTerm);
			if ((this.quarantinedTable.isNegativeSearch && !isSearchFound) || (!this.quarantinedTable.isNegativeSearch && isSearchFound)) {
				totalEmailMatch++;
			}
		}

		// filters
		if (activeFilters && !_.isEmpty(activeFilters)) {
			const {positiveFilters, negativeFilters} = this.gs.splitTableFilters(activeFilters);
			// positive filters check
			if (this.searchFilterExecute(email, positiveFilters, parentEmail) === 0) {
				// negative filters check
				if (_.isEmpty(negativeFilters) || this.searchFilterExecute(email, negativeFilters, parentEmail) === Object.keys(negativeFilters).length) {
					totalEmailMatch++;
				}
			}
		}

		// filter as tag check
		if (this.activeTagAsFilter) {
			const tags = [
				email.malicious && email.malicious.tpResults && email.malicious.tpResults.resHead && email.malicious.tpResults.resHead.sub_status && email.malicious.tpResults.resHead.sub_status.length && email.malicious.tpResults.resHead.status !== this.dic.CONSTANTS.threatProtection.status.safe ? email.malicious.tpResults.resHead.sub_status : null,
				email.malicious && email.malicious.tpResults && email.malicious.tpResults.resUrl && email.malicious.tpResults.resUrl.sub_status && email.malicious.tpResults.resUrl.sub_status.length && email.malicious.tpResults.resUrl.status !== this.dic.CONSTANTS.threatProtection.status.safe ? email.malicious.tpResults.resUrl.sub_status : null,
				email.malicious && email.malicious.tpResults && email.malicious.tpResults.resHash && email.malicious.tpResults.resHash.sub_status && email.malicious.tpResults.resHash.sub_status.length && email.malicious.tpResults.resHash.status !== this.dic.CONSTANTS.threatProtection.status.safe ? email.malicious.tpResults.resHash.sub_status : null
			]

			if (tags.includes(this.activeTagAsFilter)) {
				totalEmailMatch++
			}
		}

		let isFound = false;
		if (email.emails?.length) {
			for (let i = 0; i < email.emails.length; i++) {
				const isSubUserFound = this.searchEmailExecute(email.emails[i], searchTerm, activeFilters, email);
				email.emails[i].hide = !isSubUserFound;
				if (isSubUserFound) {
					isFound = true;
					if (!this.doNotChangeIsExpandedStates) {
						email.isExpanded = false;
					}
				}
			}
		}
		else if (totalEmailMatch === generalMatchTypes) {
			if (!this.doNotChangeIsExpandedStates) {
				email.isExpanded = false;
			}
			isFound = true;
		}

		return isFound;
	}

	searchFilterExecute = (email, filters, parentEmail) => {
		// need to match all filter types
		let numFilterToMatch = Object.keys(filters).length;
		if (filters.status && filters.status.length) {
			if (filters.status.includes('Quarantined') && email.status === this.dic.CONSTANTS.quarantinedActions.quarantine.value) {
				numFilterToMatch--;
			} else if (filters.status.includes('Released by rule') && email.status === this.dic.CONSTANTS.quarantinedActions.release.value &&
				email.reason === 'Rule') {
				numFilterToMatch--;
			} else if (filters.status.includes('Released by reviewer/recipient') && email.status === this.dic.CONSTANTS.quarantinedActions.release.value &&
				this.gs.validateEmail(email.reason)) {
				numFilterToMatch--;
			} else if (filters.status.includes('Removed by reviewer') && email.status === this.dic.CONSTANTS.quarantinedActions.remove.value &&
				this.gs.validateEmail(email.reason)) {
				numFilterToMatch--;
			} else if (filters.status.includes('Pending release') && email.status === this.dic.CONSTANTS.quarantinedActions.pending.value) {
				numFilterToMatch--;
			} else if (filters.status.includes('Release failure') && email.status === this.dic.CONSTANTS.quarantinedActions.releaseFailure.value) {
				numFilterToMatch--;
			} else if (filters.status.includes('Requested release') && email.status === this.dic.CONSTANTS.quarantinedActions.requestRelease.value) {
				numFilterToMatch--;
			} else if (filters.status.includes('Release request rejected') && email.reason === 'Release request rejected') {
				numFilterToMatch--;
			}

		}

		if (filters.category && filters.category.length) {
			if (filters.category.includes(email.category)) {
				numFilterToMatch--;
			}
		}

		if (filters['sub category'] && filters['sub category'].length) {
			if ((email.malicious.tpResults.resHead && filters['sub category'].includes(email.malicious.tpResults.resHead.category)) ||
				(email.malicious.tpResults.resHash && filters['sub category'].includes(email.malicious.tpResults.resHash.category)) ||
				(email.malicious.tpResults.resUrl && filters['sub category'].includes(email.malicious.tpResults.resUrl.category))) {
				numFilterToMatch--;
			}
		}

		if (filters['has links'] && filters['has links'].length) {
			if ((filters['has links'].includes('Yes') && email.links) ||
				(filters['has links'].includes('No') && !email.links)) {
				numFilterToMatch--;
			}
		}

		if (filters['has attachments'] && filters['has attachments'].length) {
			if ((filters['has attachments'].includes('Yes') && email.attachments) ||
				(filters['has attachments'].includes('No') && !email.attachments)) {
				numFilterToMatch--;
			}
		}

		if (filters['Preserve record'] && filters['Preserve record'].length) {
			if ((filters['Preserve record'].includes('Yes') && email.keep_forever) ||
				(filters['Preserve record'].includes('No') && !email.keep_forever)) {
				numFilterToMatch--;
			}
		}

		if (filters['reported by'] && filters['reported by'].length) {
			if ((filters['reported by'].includes('Reviewer') && email.report?.report_by === 'reviewer') ||
				(filters['reported by'].includes('Recipient') && email.report?.report_by === 'recipient') ||
				(filters['reported by'].includes('Third party') && email.report?.report_by === 'Microsoft')) {
				numFilterToMatch--;
			}
		}

		if (filters.handled && filters.handled.length) {
			if (parentEmail && filters.handled.includes(parentEmail.reviewed_completed)) {
				numFilterToMatch--;
			}
		}

		if (filters['Executive Recipient'] && filters['Executive Recipient'].length) {
			if (email.malicious.tpResults.resHead) {
				if ((filters['Executive Recipient'].includes('Yes') && email.malicious.tpResults.resHead.isExecutiveRecipient) ||
					(filters['Executive Recipient'].includes('No') && !email.malicious.tpResults.resHead.isExecutiveRecipient)) {
					numFilterToMatch--;
				}
			}
		}

		if (filters.follow?.length) {
			if (filters.follow.includes(email.mark_follow)) {
				numFilterToMatch--;
			}
		}

		if (filters.poc?.length) {
			if ((filters.poc.includes(true) && this.pocPlans.includes(email.plan_id)) ||
				(filters.poc.includes(false) && !this.pocPlans.includes(email.plan_id))) {
				numFilterToMatch--;
			}
		}

		if (filters['Sender Type'] && filters['Sender Type'].length) {
			const head = email.malicious?.tpResults?.resHead;
			if ((filters['Sender Type'].includes('External sender') && head?.isExternal) ||
				(filters['Sender Type'].includes('Internal sender') && head && !head.isExternal) ||
				(filters['Sender Type'].includes('Free email domain') && head?.isFreeEmail) ||
				(filters['Sender Type'].includes('Top domain') && (head?.isTopDomain || head?.isBrandService)) ||
				(filters['Sender Type'].includes('Unknown sender') && head?.isUnknownSender) ||
				(filters['Sender Type'].includes('Known Contact') && (head?.isKnownContact || head?.isCertainContact))) {
				numFilterToMatch--;
			}
		}

		if (filters.plans?.length) {
			const planIDs = [];
			this.viewPlanList.forEach((planObj) => {
				if (filters.plans.includes(planObj.display_email)) {
					planIDs.push(planObj.alloc_plan_id?._id.toString() || this.userInfo.plan._id.toString());
				}
			});
			if (planIDs.includes(email.plan_id)) {
				numFilterToMatch--;
			}
		}

		if (filters.subject && filters.subject.length) {
			if (email.subject) {
				let isSubjectFound = false;
				const emailLowerCase = email.subject.toLowerCase();

				for (let i = 0; i < filters.subject.length; i++) {
					const subject = filters.subject[i];

					// Find the filter for the current subject
					const filter = this.quarantineSubjectFilters.find(subjectItm => subjectItm.name === subject || subjectItm.aliases.includes(subject));

					// If a matching filter is found, check if any of the keywords match the email subject
					if (filter && filter.keywords.some(keywordItm =>
						(filter.regex
							? new RegExp(keywordItm).test(emailLowerCase)
							: emailLowerCase.includes(keywordItm))
						)
					) {
						isSubjectFound = true;
						break; // Once a match is found, exit the loop
					}
				}

				if (isSubjectFound) {
					numFilterToMatch--;
				}
			}
		}

		return numFilterToMatch;
	}

	toggleExpandItem = (item, event) => {
		if (!item.emails?.length) {
			return;
		}

		item.isExpanded = !item.isExpanded;
		event.stopPropagation();
		this.doNotChangeIsExpandedStates = true;
	}

    calculateTags = (email) => {
        let threatTags = [];
        if (email.malicious && email.malicious.tpResults) {
            if (email.malicious.tpResults.resHead && email.malicious.tpResults.resHead.sub_status && email.malicious.tpResults.resHead.sub_status.length && email.malicious.tpResults.resHead.status !== this.dic.CONSTANTS.threatProtection.status.safe) {
                const tagInfo = {
                    status: email.malicious.tpResults.resHead.status,
                    name: email.malicious.tpResults.resHead.sub_status,
                    colorObj: this.setInboundStatusStyles(email.malicious.tpResults.resHead.status)
                };
                threatTags.push(tagInfo);
            }
            if (email.malicious.tpResults.resUrl && email.malicious.tpResults.resUrl.sub_status && email.malicious.tpResults.resUrl.sub_status.length && email.malicious.tpResults.resUrl.status !== this.dic.CONSTANTS.threatProtection.status.safe) {
                const tagInfo = {
                    status: email.malicious.tpResults.resUrl.status,
                    name: email.malicious.tpResults.resUrl.sub_status,
                    colorObj: this.setInboundStatusStyles(email.malicious.tpResults.resUrl.status)
                };
                threatTags.push(tagInfo);
            }
            if (email.malicious.tpResults.resHash && email.malicious.tpResults.resHash.sub_status && email.malicious.tpResults.resHash.sub_status.length && email.malicious.tpResults.resHash.status !== this.dic.CONSTANTS.threatProtection.status.safe) {
                const tagInfo = {
                    status: email.malicious.tpResults.resHash.status,
                    name: email.malicious.tpResults.resHash.sub_status,
                    colorObj: this.setInboundStatusStyles(email.malicious.tpResults.resHash.status)
                };
                threatTags.push(tagInfo);
            }
        }

        // merge duplicates and assign to email object
        threatTags = _.uniqBy(threatTags, tag => {return tag.name;});
        email.threatTags = threatTags;
    }

    setEmailCategory = (email) => {
        if (email.malicious) {
            if (email.malicious.status_user_reported) {
                this.setEmailCategoryExecute(email, email.malicious.status_user_reported);
            }
            else {
                this.setEmailCategoryExecute(email, email.malicious.status);
            }
        }
    };

    setEmailCategoryExecute = (email, status) => {
        if (!email || !status) {
            return;
        }
        email.category = status;
        switch (status.toLowerCase()) {
            case this.dic.CONSTANTS.tpRule.name.malicious:
                email.color = 'darkred';
                email.category_priority = 1;
                break;

            case this.dic.CONSTANTS.tpRule.name.suspicious:
                email.color = 'darkred';
                email.category_priority = 2;
                break;

            case this.dic.CONSTANTS.tpRule.name.spam:
                email.color = 'darkorange';
                email.category_priority = 3;
                break;

            case this.dic.CONSTANTS.tpRule.name.graymail:
                email.color = 'dimgray';
                email.category_priority = 4;
                break;

            case this.dic.CONSTANTS.tpRule.name.external:
                email.color = 'darkorange';
                email.category_priority = 5;
                break;

            // safe
            default:
                email.color = 'darkgreen';
                email.category_priority = 6;
        }
    };


	exportQuarantinedCsv = (sortBy) => {
		if (!this.groupEmails?.length) {
			this.ns.showWarnMessage(this.dic.ERRORS.noDataToExportCsv);
			return;
		}

		let csvString = "Created,Mailbox,Sender,Subject,Attachments,Status,Category,Tags\n";

		let sortedTable = _.reject(this.groupEmails, 'hide');
		if (sortBy) {
			sortedTable = this.gs.sortTable(sortedTable, sortBy);
		}
		// CC: export each visible email of a group as its own row so the CSV count matches the UI
		sortedTable = _.flatMap(sortedTable, (record) => {
			const visibleChildren = record.emails?.filter(child => !child.hide);
			return visibleChildren?.length ? visibleChildren : [record];
		});

		sortedTable.forEach((email) => {
			let tags = '';
			if (email.malicious && email.malicious.tpResults) {
				tags = (email.malicious.tpResults.resHead && email.malicious.tpResults.resHead.sub_status && email.malicious.tpResults.resHead.sub_status.length && email.malicious.tpResults.resHead.status !== this.dic.CONSTANTS.threatProtection.status.safe && email.malicious.tpResults.resHead.sub_status.toString() + '. ' || '') +
					(email.malicious.tpResults.resUrl && email.malicious.tpResults.resUrl.sub_status && email.malicious.tpResults.resUrl.sub_status.length && email.malicious.tpResults.resUrl.status !== this.dic.CONSTANTS.threatProtection.status.safe && email.malicious.tpResults.resUrl.sub_status.toString() + '. ' || '') +
					(email.malicious.tpResults.resHash && email.malicious.tpResults.resHash.sub_status && email.malicious.tpResults.resHash.sub_status.length && email.malicious.tpResults.resHash.status !== this.dic.CONSTANTS.threatProtection.status.safe && email.malicious.tpResults.resHash.sub_status.toString()|| '');
			}

			const created = new Date(email.created);
			const createdStr = `${created.toLocaleDateString()} ${created.toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric', hour12: false })}`;
			csvString += `${createdStr},"${email.mailbox_email}",${email.sender},"${email.subject}","${email.attachments || 0}","${email.reason ? this.gs.toCapitalize(email.status)+' ('+email.reason+')' : this.gs.toCapitalize(email.status)}","${email.category}","${tags}"\n`;
		});

		this.gs.exportCsv(csvString, `quarantined_emails.csv`);
	}

    initFilters = () => {
        this.filterData = {
			filterType: this.dic.CONSTANTS.tableFilters.quarantined,
            filters: {
                status: ['Quarantined', 'Released by rule', 'Released by reviewer/recipient', 'Pending release', 'Requested release', 'Release request rejected', 'Release failure', 'Removed by reviewer'],
                category: ['Malicious', 'Suspicious', 'Spam', 'Graymail', 'External', 'Safe'],
				'sub category': [ 'Malware', 'Phishing', 'Spoofing', 'Impersonation', 'Business Email Compromise', 'Spam', 'Graymail', 'Third Party Verdict', 'User Preferences', 'Threat Intelligence', 'Blocklist', 'Allowlist' ],
                'Sender Type': ['External sender', 'Internal sender', 'Free email domain', 'Top domain', 'Unknown sender', 'Known Contact'],
				'Executive Recipient': ['Yes', 'No'],
				'has links': ['Yes', 'No'],
                'has attachments': ['Yes', 'No'],
				'Preserve record': ['Yes', 'No'],
				'reported by': ['Reviewer', 'Recipient', 'Third party'],
				subject: ['Invoices & Payments', 'Account & Security', 'Notifications & Alerts', 'Verification & Confirmation', 'Request for Quote (RFQ)', 'Reservations & Bookings', 'Replies & Forwards'],
                handled: [true, false]
            },
			tableFilterTemplatesRefName: this.dic.CONSTANTS.tableFilterTemplatesRefNames.quarantine,
			enableNegativeOptions: true,
			initFiltersFunction: this.initFilters
        };

        if (this.reviewerInfo.is_security_reviewer) {
            this.filterData.filters.follow = [true, false];
			this.filterData.filters.poc = [true, false];
        }

		if (this.viewPlanList) {
			this.filterData.filters = {
				plans: this.viewPlanList.map(itm => itm.display_email), // Add the new property first
				...this.filterData.filters         // Spread the existing properties
			};
		}

        if (this.filterData.saveAsDefault) {
            this.activeFilters = this.gs.getTableFilter(this.dic.CONSTANTS.tableFilters.quarantined);
        }
    };

	openNotifyOptionsPopup = () => {
		// create model for notifyReviewerPeriods dropdown selection (initial values from this.config)
		const notifyReviewerPeriods = {};
		_.forEach(this.dic.CONSTANTS.tpRule.notifyOptions,(periodName, periodKey) => {
			notifyReviewerPeriods[periodName] = this.mailboxInfo.notify_reviewer_periods && this.mailboxInfo.notify_reviewer_periods.includes(periodName);
		});
		let notifyReviewerDailyHours = [];
		if (this.mailboxInfo.notify_reviewer_daily_hour) {
			notifyReviewerDailyHours = this.mailboxInfo.notify_reviewer_daily_hour.split(', ');
			for (let i = 0; i < notifyReviewerDailyHours.length; i++) {
				let formattedHour:any = new Date();
				formattedHour.setUTCHours(notifyReviewerDailyHours[i]);
				formattedHour = (formattedHour.getHours() < 10 ? '0' : '') + formattedHour.getHours();
				notifyReviewerDailyHours[i] = formattedHour;
			}
		}

		const notifyReviewerDays = _.map(this.gs.daysArr, day => ({
			day: day,
			selected: this.mailboxInfo.notify_reviewer_days?.includes(day) || false
		}));

		this.notifyOptionsPopup = {
			periods: notifyReviewerPeriods,
			dailyHours: notifyReviewerDailyHours,
			notifyReviewerDays,
			isNotifyReviewerPeriodsError: false,
			isNotifyReviewerDailyHoursError: false,
			changeNotifyPeriodInProcess: false,
			currentDisplay: {
				periods: _.keys(_.pickBy(notifyReviewerPeriods)).join(', ').replace('Notify every day', 'Custom notification times') || '—',
				hours: notifyReviewerDailyHours.map(hour => hour + ':00').join(', ') || '—',
				days: notifyReviewerDays.filter(dayObj => dayObj.selected).map(dayObj => dayObj.day).join(', ') || '—',
				hasCustomTimes: !!notifyReviewerPeriods[this.dic.CONSTANTS.tpRule.notifyOptions.everyDay]
			},
			show: true,
		};
	}

	changeNotifyPeriod = () => {
		if (this.notifyOptionsPopup.changeNotifyPeriodInProcess) {
			return;
		}

		// periods validation
		const isOneReviewerPeriodEnabled = _.some(this.notifyOptionsPopup.periods, period => {return !!period});
		if (!isOneReviewerPeriodEnabled) {
			this.notifyOptionsPopup.isNotifyReviewerPeriodsError = true;
		}

		this.notifyOptionsPopup.isNotifyReviewerDailyHoursError = this.notifyOptionsPopup.periods[this.dic.CONSTANTS.tpRule.notifyOptions.everyDay] && !this.notifyOptionsPopup.dailyHours.length;
		this.notifyOptionsPopup.isNotifyReviewerDaysError = this.notifyOptionsPopup.periods[this.dic.CONSTANTS.tpRule.notifyOptions.everyDay] && !_.some(this.notifyOptionsPopup.notifyReviewerDays, { selected: true });

		if (!isOneReviewerPeriodEnabled || this.notifyOptionsPopup.isNotifyReviewerDailyHoursError || this.notifyOptionsPopup.isNotifyReviewerDaysError) {
			return;
		}
		//

		// make arrays of strings from the periods objects (pick only enabled periods)
		const notifyReviewerPeriodsArr = _.keys(_.pickBy(this.notifyOptionsPopup.periods));

		// turn the local hours in the "daily_hour" models into UTC hours for the BE
		let notifyReviewerDailyHoursUTC = _.cloneDeep(this.notifyOptionsPopup.dailyHours);
		for (let i =0 ; i < notifyReviewerDailyHoursUTC.length; i++) {
			let formattedHour:any = new Date();
			formattedHour.setHours(notifyReviewerDailyHoursUTC[i]);
			formattedHour = (formattedHour.getUTCHours() < 10 ? '0' : '') + formattedHour.getUTCHours();
			notifyReviewerDailyHoursUTC[i] = formattedHour;
		}

		const selectedNotifyReviewerDays = _.map(
			_.filter(this.notifyOptionsPopup.notifyReviewerDays, { selected: true }),
			'day'
		);

		//
		const data = {
			notifyReviewerPeriods: notifyReviewerPeriodsArr,
			notify_reviewer_daily_hour: notifyReviewerDailyHoursUTC.join(', '),
			notify_reviewer_days: selectedNotifyReviewerDays,
		};

		this.notifyOptionsPopup.changeNotifyPeriodInProcess = true;

		this.rs.updateMailboxNotification(data).then( (response) => {
			this.mailboxInfo.notify_reviewer_periods = notifyReviewerPeriodsArr;
			this.mailboxInfo.notify_reviewer_daily_hour = notifyReviewerDailyHoursUTC.join(', ');
			this.mailboxInfo.notify_reviewer_days = selectedNotifyReviewerDays;
			this.ns.showInfoMessage(this.dic.MESSAGES.changedSuccessfully);

			this.notifyOptionsPopup = null;
		}, (err) => {
			if (err && err.data && err.data.message) {
				this.ns.showErrorMessage(err.data.message);
			}
			this.notifyOptionsPopup.changeNotifyPeriodInProcess = false;
		});
	};

	searchPlan(searchTerm) {
		searchTerm = (searchTerm || '').toLowerCase();

		// Go through viewPlanList and update hide property based on match
		this.viewPlanList.forEach(plan => {
			// Check if the plan matches the search term
			plan.hide = !plan.display_email.toLowerCase().includes(searchTerm);
		});
	}

	clearSearchPlan() {
		this.searchPlanTxt = '';
		this.viewPlanList.forEach(plan => {
			plan.hide = false;
		})
	}

	toggleNotificationDailyHour = (listOfHours, targetHour) => {
		if (listOfHours.includes(targetHour)) {
			_.remove(listOfHours, hour => hour === targetHour);
		}
		else {
			listOfHours.push(targetHour);
		}
	}

	getTableQueryTemplates = () => {
		this.tableQueryTemplatesService.getTableQueryTemplates(this.dic.CONSTANTS.tableQueryTemplatesRefNames.quarantine)
			.then((templates:any[]) => {
				const defaultTemplate = _.find(templates, 'default');
				// check whether another predefined query was already applied before selecting the default template
				if (defaultTemplate && !this.currentQuery) {
					this.selectQueryTemplate(defaultTemplate.query);
					this.tableQueryTemplatesService.selectedTemplate = defaultTemplate;
					this.tableQueryTemplatesService.isSomeValueChanged = false;
				}
			});
	}

}



function calcParentEmailCategory(parentEmail) {
    if (!parentEmail.emails || !parentEmail.emails.length) {
        return;
    }

    let emailPriority = parentEmail.emails[0];
    parentEmail.keep_forever = parentEmail.emails[0].keep_forever;
    parentEmail.emails.forEach((emailObj) => {
        if (emailObj.category !== emailPriority.category) {
            parentEmail.diffCategory = true;
        }
        if (emailObj.category_priority < emailPriority.category_priority) {
            emailPriority = emailObj;
        }
        parentEmail.keep_forever = parentEmail.keep_forever && emailObj.keep_forever;
    });

    // general data for showing the group as message in the UI
    parentEmail.threatTags = emailPriority.threatTags;
    parentEmail.malicious = emailPriority.malicious;
    parentEmail.reason = emailPriority.reason;
    parentEmail.category = emailPriority.category;
    parentEmail.color = emailPriority.color;
    parentEmail.category_priority = emailPriority.category_priority;
    parentEmail.status = emailPriority.status;
}

// when parent record is found by search and/or filter, remove hide flag from it's children recursively
function showAllSubMailboxes(emailRecord) {
	if (emailRecord.emails?.length) {
		emailRecord.emails.forEach(mailboxEmail => {
			mailboxEmail.hide = false;
		});
	}
}

function searchTextExecute(email, searchTerm) {
	searchTerm = searchTerm.toLowerCase();
	return ((email.mailbox_email && typeof email.mailbox_email === 'string' && (email.mailbox_email.toLowerCase().indexOf(searchTerm) > -1)) ||
		(email.sender?.toLowerCase().indexOf(searchTerm) > -1) ||
		(email.subject && ((email.subject.toLowerCase().indexOf(searchTerm) > -1) ||
		(email.malicious.tpResults.resHead?.from?.senderMailFrom?.toLowerCase().indexOf(searchTerm) > -1) ||
		(email.malicious.tpResults.resHead?.from?.receivedSPF?.domain?.toLowerCase().indexOf(searchTerm) > -1) ||
		(email.malicious.tpResults.resHead?.from?.ipAddresses?.includes(searchTerm)) ||
		(email.malicious.tpResults.resHead?.from?.sendingMTAFull?.toLowerCase().indexOf(searchTerm) > -1) ||
		(email.malicious.tpResults.resHead?.from?.sendingMTA?.domain?.toLowerCase().indexOf(searchTerm) > -1))) ||
		(email.message_id && email.message_id.toLowerCase().indexOf(searchTerm) > -1) ||
		(email.reason?.toLowerCase().indexOf(searchTerm) > -1) ||
		(email.threatTags && email.threatTags.length && email.threatTags.find(itm => itm.name.toLowerCase().indexOf(searchTerm) > -1)));
}


function diffMinutes(dt2, dt1) {
    let diff = (new Date(dt2).getTime() - new Date(dt1).getTime()) / 1000;
    diff /= 60;
    return Math.abs(Math.round(diff));
}

function initializeValues(obj) {
	for (let key in obj) {
		obj[key] = false;
	}
}
